import { ModalMotivosPage } from "./../pages/modal-motivos/modal-motivos";
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { HttpModule } from "@angular/http";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MyApp, MyErrorHandler } from "./app.component";
import { HomePage } from "../pages/home/home";
import { LoginPage } from "../pages/login/login";
import { SalirPage } from "../pages/salir/salir";

import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { API, APIOnLine } from "../services/api/api.services";
import { pouchdb, pouchdb2 } from "../services/pouchdb/pouchdb.service";
import { ProyectoGanarService } from "../services/api/ganar.services";
import { OtrosAuxiliaresAmonestacionService, OtrosAuxiliaresService } from "../services/api/otrosauxiliares.service";

import "materialize-css";
import { MaterializeModule } from "angular2-materialize";

import { SignaturePadModule } from "angular2-signaturepad";

import { EquipoPage } from "../pages/equipo/equipo";
import { JugadoresPage } from "../pages/jugadores/jugadores";
import { EntrenadoresPage } from "../pages/entrenadores/entrenadores";
import { AuxiliaresPage } from "../pages/auxiliares/auxiliares";
import { IncluirJugadorPage } from "../pages/incluir-jugador/incluir-jugador";
import { NuevaPersonaPage } from "../pages/nueva-persona/nueva-persona";

import { AuxiliaresPipe } from "../pipes/auxiliares";
import { PorNombrePipe } from "../pipes/porNombre";
import { AlineacionPage } from "../pages/alineacion/alineacion";
import { FirmasPage } from "../pages/firmas/firmas";
import { ResultadoPage } from "../pages/resultado/resultado";
import { GolesPage } from "../pages/goles/goles";
import { AmonestacionesPage } from "../pages/amonestaciones/amonestaciones";
import { ModalCodigoAmonestacionPage } from "../pages/modal-codigo-amonestacion/modal-codigo-amonestacion";
import { PorCodigoAmonestacionPipe } from "../pipes/por-codigo-amonestacion";
import { CambiosPage } from "../pages/cambios/cambios";
import { DerechosPage } from "../pages/derechos/derechos";
import { IncidenciasPage } from "../pages/incidencias/incidencias";
import { ResumenPage } from "../pages/resumen/resumen";
import { AsistentesPage } from "../pages/asistentes/asistentes";
import { CustodiaPage } from "../pages/custodia/custodia";
import { ModalActivarAlineacionesPage } from "../pages/modal-activar-alineaciones/modal-activar-alineaciones";
import { ModalRecibiPage } from "../pages/modal-recibi/modal-recibi";
import { ParticipacionPage } from "../pages/participacion/participacion";
import { QuintetoPage } from "../pages/quinteto/quinteto";
import { TiempoMuertoPage } from "../pages/tiempo-muerto/tiempo-muerto";
import { AjustesPage } from "../pages/ajustes/ajustes";
import { FinalizarPage } from "../pages/finalizar/finalizar";
import { RegistroLogsPage } from "../pages/registro-logs/registro-logs";
import { DeclaracionesPage } from "../pages/declaraciones/declaraciones";

import { Device } from "@ionic-native/device";
import { Network } from "@ionic-native/network";
import { ModalDorsalPage } from "../pages/modal-dorsal/modal-dorsal";
import { DesignacionesCompletasPage } from "../pages/designaciones-completas/designaciones-completas";
import { ModalSuperPage } from "../pages/modal-super/modal-super";
import { PorRegistroPipe } from "../pipes/por-registro";

import { CabeceraComponent } from "../components/cabecera/cabecera";
import { MenuDerechoComponent } from "../components/menu-derecho/menu-derecho";
import { SignatureComponent } from "../components/signature/signature";
import { NuevoMenuDerechoComponent } from "../components/nuevo-menu-derecho/nuevo-menu-derecho";
import { ResultadoParcialComponent } from "../components/resultado-parcial/resultado-parcial";

import { AdministradorPage } from "../pages/administrador/administrador";
import { ModalImagePage } from "../pages/modal-image/modal-image";

import { NgxDropzoneModule } from "ngx-dropzone";
import { Ng2ImgMaxModule } from "ng2-img-max";
import { JoditAngularModule } from "jodit-angular";
import { OtrosAuxiliaresPage } from "../pages/otros-auxiliares/otros-auxiliares";
import { LesionadosPage } from "../pages/lesionados/lesionados";
import { LesionadosService } from "../services/api/lesionados.service";
import { EstadisticasService } from "../services/api/estadisticas.service";

@NgModule({
  declarations: [
    MyApp,
    EquipoPage,
    HomePage,
    LoginPage,
    SalirPage,
    JugadoresPage,
    EntrenadoresPage,
    AuxiliaresPage,
    IncluirJugadorPage,
    NuevaPersonaPage,
    AlineacionPage,
    FirmasPage,
    ResultadoPage,
    GolesPage,
    AmonestacionesPage,
    CambiosPage,
    DerechosPage,
    IncidenciasPage,
    ResumenPage,
    AsistentesPage,
    CustodiaPage,
    ParticipacionPage,
    QuintetoPage,
    TiempoMuertoPage,
    AjustesPage,
    FinalizarPage,
    DesignacionesCompletasPage,
    RegistroLogsPage,
    AdministradorPage,
    DeclaracionesPage,
    OtrosAuxiliaresPage,
    LesionadosPage,

    ModalCodigoAmonestacionPage,
    ModalDorsalPage,
    ModalActivarAlineacionesPage,
    ModalRecibiPage,
    ModalSuperPage,
    ModalImagePage,
    ModalMotivosPage,

    CabeceraComponent,
    MenuDerechoComponent,
    NuevoMenuDerechoComponent,
    SignatureComponent,
    ResultadoParcialComponent,

    AuxiliaresPipe,
    PorNombrePipe,
    PorCodigoAmonestacionPipe,
    PorRegistroPipe,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      tabsPlacement: "bottom",
    }),
    HttpClientModule,
    HttpModule,
    MaterializeModule,
    SignaturePadModule,
    NgxDropzoneModule,
    Ng2ImgMaxModule,
    JoditAngularModule,
    FormsModule,
    ReactiveFormsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    EquipoPage,
    HomePage,
    LoginPage,
    SalirPage,

    JugadoresPage,
    EntrenadoresPage,
    AuxiliaresPage,
    IncluirJugadorPage,
    NuevaPersonaPage,
    AlineacionPage,
    FirmasPage,
    ResultadoPage,
    GolesPage,
    AmonestacionesPage,
    CambiosPage,
    DerechosPage,
    IncidenciasPage,
    ResumenPage,
    AsistentesPage,
    CustodiaPage,
    ParticipacionPage,
    QuintetoPage,
    TiempoMuertoPage,
    AjustesPage,
    FinalizarPage,
    DesignacionesCompletasPage,
    RegistroLogsPage,
    AdministradorPage,
    DeclaracionesPage,
    OtrosAuxiliaresPage,
    LesionadosPage,

    ModalCodigoAmonestacionPage,
    ModalDorsalPage,
    ModalActivarAlineacionesPage,
    ModalRecibiPage,
    ModalSuperPage,
    ModalImagePage,
    ModalMotivosPage,

    MenuDerechoComponent,
    NuevoMenuDerechoComponent,
    SignatureComponent,
    CabeceraComponent,
    ResultadoParcialComponent,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    API.CodigosAmonestacionService,
    API.DesignacionesService,
    API.ImagenesService,
    API.LicenciasService,
    API.UsuariosService,
    API.ParametrosAlineacion,
    API.SessionService,
    pouchdb.DBService,
    pouchdb2.DBService2,

    // API OnLine
    APIOnLine.CFutbolActas,
    APIOnLine.Persistentes,
    APIOnLine.DeclaracionesCOVIDDesignacionService,
    APIOnLine.InformacionEnActaService,
    ProyectoGanarService,
    OtrosAuxiliaresService,
    OtrosAuxiliaresAmonestacionService,
    LesionadosService,
    EstadisticasService,

    // Providers de Ionic Native
    Device,
    Network,

    // Providers para el control de errores
    IonicErrorHandler,
    [
      {
        provide: ErrorHandler,
        useClass: MyErrorHandler,
      },
    ],
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts